



























import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component({ name: 'GStudentImportYearConfirmModal' })
export default class GStudentImportYearConfirmModal extends Vue {
  show: boolean = false;

  @Prop() value: boolean;
  @Prop({ default: 0 }) year: number;

  @Watch('value')
  onValueChange(v: boolean) {
    this.show = v;
  }

  @Watch('show')
  onShowChange(v: boolean) {
    this.$emit('input', v);
  }

  handleBack() {
    this.show = false;
    this.$emit('back');
  }

  handleOK() {
    this.show = false;
    this.$emit('ok');
  }
}
